<div class="row g-4 mb-4">
  <cfp-input-search class="col" [showButton]="false" [(ngModel)]="searchText" />
  <cfp-button class="col-auto" (clicked)="openAddTagModal()" [buttonSize]="'small'" [dataTest]="'addTag'">
    {{ 'tags.add' | translate }}
  </cfp-button>
</div>
